export default "__VITE_ASSET__Udes3qd$__"